import { useCallback, useEffect } from 'react';
import { defineMessage, useIntl } from 'react-intl';

import { useSnackbar } from '../lib/snackbar/snackbar';
import { globalErrorHandler, HandledGlobalErrorsType } from '../modules/globalErrorHandler';

const effectDestructor = () => {
  (Object.keys(globalErrorHandler) as HandledGlobalErrorsType[]).forEach((value) => {
    globalErrorHandler[value] = () => null;
  });
};

const throttlingErrorMessage = defineMessage({
  id: 'error-messages:api-call-rate-limited',
  defaultMessage: "You've recently made too many attempts to make a change. Please try again later.",
  description: 'Rate limiting error message',
});

export const GlobalErrorHandlerProvider = () => {
  const intl = useIntl();
  const snackbar = useSnackbar();

  const throttlingErrorHandler = useCallback(() => {
    snackbar.open(intl.formatMessage(throttlingErrorMessage), { variant: 'info' });
  }, [intl, snackbar]);

  useEffect(() => {
    globalErrorHandler.showRateLimitedSnackbar = throttlingErrorHandler;
    return effectDestructor;
  }, [throttlingErrorHandler]);

  return null;
};
